import { areaUtils_validType } from 'app/shared/utils/areaUtils';
import { listingUtils_districtTypeLegend, listingUtils_schoolTypeLegend } from 'app/shared/utils/listingUtils';
import Area, { type AreaResponse } from 'app/shared/models/Area';
import AreaPriceComparison from 'app/shared/models/AreaPriceComparison';

interface AreasInput {
  breadcrumbs?: Array<AreaResponse>;
  links?: Array<AreaResponse>;
}

interface Model {
  low: number;
  high: number;
}

interface PricingInput {
  models?: Array<Model>;
  summary?: {
    priceLow?: number;
    priceHigh?: number;
  };
}

interface PricingStatsInput {
  [key: string]: string;
}

interface ListingAreasProps {
  searchSlug?: string;
  areas?: AreasInput;
  pricingStats?: PricingStatsInput;
  pricing?: PricingInput;
}

type SchoolType = 'primaryschool' | 'middleschool' | 'highschool' | 'mixedschool' | 'university';

interface SchoolsCollection {
  primaryschool: Array<Area>;
  middleschool: Array<Area>;
  highschool: Array<Area>;
  mixedschool: Array<Area>;
  university: Array<Area>;
}

interface ListingAreasInstance {
  breadcrumbs: Array<Area>;
  surroundingAreaStats: AreaPriceComparison;
  links: Array<Area>;
  districts: Array<Area>;
  schools: SchoolsCollection;
}

const ListingAreas = function (
  this: ListingAreasInstance,
  { searchSlug = '', areas = {}, pricingStats = {}, pricing = {} }: ListingAreasProps = {},
) {
  const breadcrumbs = areas.breadcrumbs || [];
  const links = areas.links || [];
  const parsedBreadcrumbs: Array<Area> = [];
  const parsedLinks: Array<Area> = [];
  const parsedDistricts: Array<Area> = [];
  const parsedSchools: SchoolsCollection = {
    primaryschool: [],
    middleschool: [],
    highschool: [],
    mixedschool: [],
    university: [],
  };

  breadcrumbs.forEach((area) => {
    if (areaUtils_validType(area.type)) {
      parsedBreadcrumbs.push(new Area(area));
    }
  });

  links.forEach((area) => {
    if (areaUtils_validType(area.type)) {
      area.uriV2 = '/' + area.resourceId + '/' + searchSlug;
      parsedLinks.push(new Area(area));
    }
  });

  links.forEach((area) => {
    if (areaUtils_validType(area.type) && area.type in listingUtils_districtTypeLegend) {
      parsedDistricts.push(new Area(area));
    }
  });

  links.forEach((area) => {
    if (areaUtils_validType(area.type) && area.type in listingUtils_schoolTypeLegend) {
      parsedSchools[area.type as SchoolType].push(new Area(area));
    }
  });

  this.breadcrumbs = [].concat(parsedBreadcrumbs as []);
  this.surroundingAreaStats = new AreaPriceComparison({ links: parsedLinks, pricingStats, pricing });
  this.links = [].concat(parsedLinks as []);
  this.districts = [].concat(parsedDistricts as []);
  this.schools = {
    primaryschool: [].concat(parsedSchools.primaryschool as []),
    middleschool: [].concat(parsedSchools.middleschool as []),
    highschool: [].concat(parsedSchools.highschool as []),
    mixedschool: [].concat(parsedSchools.mixedschool as []),
    university: [].concat(parsedSchools.university as []),
  };
};

export default ListingAreas;
